import React, { useEffect } from "react";
import { StyleSheet, Text, View, ScrollView } from "react-native";
import BackButton from "../../components/BackButton";
import Lock from "../../assets/svg/Lock";
import PieStat from "../../components/LGL/PieStat";
import Rewards from "../../components/LGL/Rewards";
import TnC from "../../components/LGL/TnC";
import PreviousMonthStats from "../../components/LGL/PreviousMonthStats";
import analytics from "../../services/analytics";
import { LGL } from "../../constants/analyticsEventsCT";

import t from "@constants/localization";

const PATH = "screens/LGL/LeaderLadderDetails";

const LeaderLadderDetails = (props) => {
  const { navigation, route: { params = {} } = {} } = props;

  const { data = {}, locked = true, widget = {} } = params || {};

  const { name = "", eligibility = [], tnc, rewards = [] } = data || {};

  useEffect(() => {
    analytics.trackEvent(LGL.LGL_VIEW_DETAILS, {
      locked,
    });
  }, [locked]);

  return (
    <View>
      <View style={{ backgroundColor: "white" }}>
        <HeaderWithBackAndTitle
          navigation={navigation}
          name={name}
          locked={locked}
        />
      </View>
      <ScrollView style={styles.body}>
        <TargetRequired name={name} eligibility={eligibility} locked={locked} />
        <View style={{ paddingHorizontal: 15 }}>
          <Text style={{ fontFamily: "NotoSansDevanagari-Bold", fontSize: 16 }}>
            {name}
            {t(`${PATH}/benefitsToBecome`)}
          </Text>
          <Rewards rewards={rewards} disabled={locked} />
          {locked ? <TnC tnc={tnc} /> : <PreviousMonthStats widget={widget} />}
        </View>
      </ScrollView>
    </View>
  );
};

const HeaderWithBackAndTitle = ({ navigation, name = "", locked }) => (
  <View
    style={{
      paddingVertical: 13,
      flexDirection: "row",
      alignItems: "center",
      borderBottomColor: "rgba(28,28,28, 0.1)",
      borderBottomWidth: 1,
    }}
  >
    <BackButton onPress={navigation.goBack} />
    <Text
      style={{
        fontFamily: "NotoSansDevanagari-Bold",
        color: "black",
        fontSize: 20,
        marginLeft: 20,
        marginRight: 13,
      }}
    >
      {`${locked ? t(`${PATH}/unlock`) : ""}${name}`}
    </Text>
    {locked && <Lock />}
  </View>
);

const TargetRequired = ({ eligibility = [], name, locked }) => {
  return (
    <View
      style={{
        paddingHorizontal: 15,
      }}
    >
      <Text
        style={{
          fontFamily: "NotoSansDevanagari-Bold",
          fontSize: 16,
          marginTop: 20,
        }}
      >
        {name} {t(`${PATH}/targetToBecome`)}
      </Text>
      <View
        style={{
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "space-between",
          paddingBottom: 5,
        }}
      >
        {eligibility.map((item) => (
          <PieStat
            key={item.id}
            percentage={Math.min((item.current_state * 100) / item.target, 100)}
            title={item.title_text_template}
            subTitle={item.sub_title_text_template}
            disabled={locked}
          />
        ))}
      </View>
    </View>
  );
};

export default LeaderLadderDetails;

const styles = StyleSheet.create({
  body: {},
});
